// Module
var code = "<a href=javascript:; class=page-head-voltar @click=doBack> <i class=\"material-icons phv-icon\">arrow_back</i>&nbsp;Voltar </a> ";
// Exports
module.exports = code;